import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsArticle, CmsCollection } from '@fcom/core-api';
import { CmsModule } from '@fcom/cms/components';
import { IconsModule } from '@fcom/ui-components';
import { PipesModule } from '@fcom/common';
import { FragmentService } from '@fcom/common/services';

import { AccordionItemComponent } from '../../../common/components/accordion-list/accordion-item.component';
import { AccordionListComponent } from '../../../common/components/accordion-list/accordion-list.component';
import { MmbSplitPanelComponent } from '../../../common/components/mmb-split-panel/mmb-split-panel.component';

@Component({
  selector: 'fin-mmb-insurance-panel',
  templateUrl: './insurance-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    MmbSplitPanelComponent,
    AccordionListComponent,
    AccordionItemComponent,
    CmsModule,
    IconsModule,
    PipesModule,
  ],
})
export class InsurancePanelComponent implements OnInit {
  private fragmentService = inject(FragmentService);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  readonly insuranceName = input.required<string>();
  readonly cmsFragmentPrefix = input('MMB.fragments.allianz');

  infoContent$: Observable<CmsArticle>;
  items$: Observable<CmsCollection<CmsArticle>>;
  termsAndConditions$: Observable<CmsArticle>;

  ngOnInit(): void {
    const prefix = `${this.cmsFragmentPrefix()}.${this.insuranceName()}`;
    this.infoContent$ = this.fragmentService.getFragment<CmsArticle>(`${prefix}.infoContent.url`);
    this.items$ = this.fragmentService.getFragment<CmsCollection<CmsArticle>>(`${prefix}.benefits.url`);
    this.termsAndConditions$ = this.fragmentService.getFragment<CmsArticle>(`${prefix}.termsAndConditions.url`);
  }
}
